import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import { useParams, withRouter } from 'react-router';
import EdtDynamicCheckLogEditService from '../service/EdtDynamicCheckLogEditService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = data => {
	return {
		key: 'edtDynamicCheckLogEditForm',
		topic: 'edtDynamicCheckLog',
		service: EdtDynamicCheckLogEditService,
		tabList: initData => {
			return [{ key: 'basic' }];
		},
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
			];

			return fields;
		}
	};
};

function EdtDynamicCheckLogEditForm() {
	const { id } = useParams();
	const myConfig = config({ id });

	return (
		<EditFormPage config={myConfig} />
	);
}

export default withRouter(EdtDynamicCheckLogEditForm);